import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface PrevButtonData {
  title: string;
}

@Component({
  selector: 'app-prev-button',
  templateUrl: './prev-button.component.html',
  styleUrls: ['./prev-button.component.scss']
})
export class PrevButtonComponent {

  @Input() public data: PrevButtonData;

  @Output() public btnClicked: EventEmitter<any> = new EventEmitter();

  public clickAction(value): void {
    this.btnClicked.emit(value);
  }
}
